import { render, staticRenderFns } from "./IngredientItem.vue?vue&type=template&id=f63a7928&scoped=true"
import script from "./IngredientItem.vue?vue&type=script&lang=js"
export * from "./IngredientItem.vue?vue&type=script&lang=js"
import style0 from "./IngredientItem.vue?vue&type=style&index=0&id=f63a7928&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63a7928",
  null
  
)

export default component.exports